import { Text } from 'bold-ui'
import React from 'react'
import { calcularIMC } from 'util/atendimento'
import { formatNumber } from 'util/number'
import { ParticipanteModel } from 'view/atividade-coletiva/model-atividadeColetiva'

interface ParticipanteImcProps {
  participante: ParticipanteModel
}

export const ParticipanteImc = ({ participante }: ParticipanteImcProps) => {
  if (participante.peso && participante.altura) {
    const imc = formatNumber(calcularIMC(participante.peso, participante.altura))
    return <Text>{imc}</Text>
  }

  return <>-</>
}
